import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1.428;

const LocationIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 14;

	if (size) {
		height = size;
	}

	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 14 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7 0C3.1402 0 0 3.15422 0 7.03125C0 8.34117 0.361239 9.61953 1.04491 10.7286L6.60154 19.723C6.70798 19.8953 6.89551 20 7.09718 20C7.09874 20 7.10026 20 7.10181 20C7.30524 19.9984 7.49315 19.8905 7.59765 19.7152L13.0127 10.6336C13.6586 9.54797 14 8.30231 14 7.03125C14 3.15422 10.8598 0 7 0ZM12.0115 10.032L7.08836 18.2885L2.03649 10.1112C1.46743 9.18805 1.15889 8.12305 1.15889 7.03125C1.15889 3.80039 3.7835 1.16406 7 1.16406C10.2165 1.16406 12.8372 3.80039 12.8372 7.03125C12.8372 8.09066 12.549 9.12844 12.0115 10.032Z"
				fill={color}
			/>
			<path
				d="M6.99945 3.51562C5.09971 3.51562 3.55414 5.09273 3.55414 7.03125C3.55414 8.95738 5.07455 10.5469 6.99945 10.5469C8.94808 10.5469 10.4448 8.93621 10.4448 7.03125C10.4448 5.09273 8.8992 3.51562 6.99945 3.51562ZM6.99945 9.38281C5.72633 9.38281 4.69492 8.32684 4.69492 7.03125C4.69492 5.73891 5.73295 4.67969 6.99945 4.67969C8.26595 4.67969 9.30015 5.73891 9.30015 7.03125C9.30015 8.30793 8.29274 9.38281 6.99945 9.38281Z"
				fill={color}
			/>
		</svg>
	);
};

export default LocationIcon;
